<template>
  <loading-logo v-if="fetchingPrivateKeys" />
  <main v-else>
    <section style="padding-left: 8px">
      <HeaderSection
        :title="$t('message.pages.drm.drmListKeys.title')"
        :subtitle="$t('message.pages.drm.drmListKeys.description')"
      />
    </section>

    <section
      v-if="groupPrivateTokens.length > 0"
      style="overflow-x: auto; overflow-y: hidden"
    >
      <div class="d-flex align-center justify-space-between my-6 mb-3">
        <div style="width: 368px; padding-left: 8px">
          <v-input
            prepend-inner-icon="mdi-magnify"
            class="search-bar"
            v-model="searchKeysText"
            size="small"
            hide-details
            :placeholder="$t('message.pages.drm.drmListKeys.searchKey')"
            ><template v-slot:prepend-inner>
              <v-icon class="neutral-60--text" size="16"> panda-search </v-icon>
            </template></v-input
          >
        </div>
        <span class="body-regular-smaller textType6--text ml-2"
          >{{ filteredKeys.length }}
          {{
            filteredKeys.length > 1
              ? $t('message.Keys').toLowerCase()
              : $t('message.commom.key').toLowerCase()
          }}</span
        >
      </div>
      <v-row
        class="mt-2"
        no-gutters
        style="padding-left: 8px; align-items: center"
      >
        <v-tooltip bottom
          ><template v-slot:activator="{ on, attrs }"
            ><v-btn v-bind="attrs" v-on="on" icon @click="getPrivateTokens"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.99873 2.66659C6.58469 2.66692 5.22864 3.22878 4.22874 4.22868C3.22855 5.22888 2.66665 6.58543 2.66665 7.99992C2.66665 8.36811 2.36817 8.66659 1.99998 8.66659C1.63179 8.66659 1.33331 8.36811 1.33331 7.99992C1.33331 6.23181 2.03569 4.53612 3.28593 3.28587C4.53618 2.03563 6.23187 1.33325 7.99998 1.33325H8.00249C9.85189 1.34021 11.627 2.06185 12.9567 3.34727L12.9647 3.35518L14.4714 4.86185C14.7317 5.1222 14.7317 5.54431 14.4714 5.80466C14.211 6.06501 13.7889 6.06501 13.5286 5.80466L12.026 4.30208C10.9444 3.25848 9.50177 2.67256 7.99873 2.66659Z"
                  fill="#636578"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 1.33325C14.3682 1.33325 14.6666 1.63173 14.6666 1.99992V5.33325C14.6666 5.70144 14.3682 5.99992 14 5.99992H10.6666C10.2985 5.99992 9.99998 5.70144 9.99998 5.33325C9.99998 4.96506 10.2985 4.66659 10.6666 4.66659H13.3333V1.99992C13.3333 1.63173 13.6318 1.33325 14 1.33325Z"
                  fill="#636578"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 7.33325C14.3682 7.33325 14.6666 7.63173 14.6666 7.99992C14.6666 9.76803 13.9643 11.4637 12.714 12.714C11.4638 13.9642 9.76809 14.6666 7.99998 14.6666L7.99747 14.6666C6.14807 14.6596 4.37295 13.938 3.04328 12.6526L3.03524 12.6447L1.52858 11.138C1.26823 10.8776 1.26823 10.4555 1.52858 10.1952C1.78892 9.93483 2.21103 9.93483 2.47138 10.1952L3.97395 11.6977C5.05552 12.7414 6.49822 13.3273 8.00129 13.3333C9.41531 13.3329 10.7713 12.771 11.7712 11.7712C12.7714 10.771 13.3333 9.41441 13.3333 7.99992C13.3333 7.63173 13.6318 7.33325 14 7.33325Z"
                  fill="#636578"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.33331 10.6666C1.33331 10.2984 1.63179 9.99992 1.99998 9.99992H5.33331C5.7015 9.99992 5.99998 10.2984 5.99998 10.6666C5.99998 11.0348 5.7015 11.3333 5.33331 11.3333H2.66665V13.9999C2.66665 14.3681 2.36817 14.6666 1.99998 14.6666C1.63179 14.6666 1.33331 14.3681 1.33331 13.9999V10.6666Z"
                  fill="#636578"
                />
              </svg> </v-btn
          ></template>
          <span>{{ $t('message.actions.refresh') }}</span>
        </v-tooltip>
        <base-btn class="mr-4 ml-1" size="xsmall" @click="addKey">{{
          $t('message.pages.drm.addKey')
        }}</base-btn>
        <base-btn type="tertiary" size="xsmall" @click="openImportKeysModal">
          <span class="d-flex align-center"
            ><svg
              class="mr-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.52843 1.52861C7.78878 1.26826 8.21089 1.26826 8.47124 1.52861L12.4712 5.52861C12.7316 5.78896 12.7316 6.21107 12.4712 6.47141C12.2109 6.73176 11.7888 6.73176 11.5284 6.47141L8.6665 3.60949V11.3333C8.6665 11.7015 8.36803 12 7.99984 12C7.63165 12 7.33317 11.7015 7.33317 11.3333V3.60949L4.47124 6.47141C4.21089 6.73176 3.78878 6.73176 3.52843 6.47141C3.26808 6.21107 3.26808 5.78896 3.52843 5.52861L7.52843 1.52861ZM2.6665 14C2.6665 13.6318 2.96498 13.3333 3.33317 13.3333H12.6665C13.0347 13.3333 13.3332 13.6318 13.3332 14C13.3332 14.3682 13.0347 14.6667 12.6665 14.6667H3.33317C2.96498 14.6667 2.6665 14.3682 2.6665 14Z"
                :fill="$vuetify.theme.dark ? '#C2C5D6' : '#3F404C'"
              /></svg
            >{{ $t('message.pages.drm.importCsvModal.import') }}</span
          ></base-btn
        >
      </v-row>
      <div style="padding-left: 4px; height: 470px; min-width: 600px">
        <BaseTable
          :items="filteredKeys"
          :columns="tableColumns"
          :bodyHeight="450"
          :selectable="true"
          :selected-items="selectedKeys"
          @sort="handleSort"
          @select-all="selectAllTokens"
          @select-row="checkboxSelectionToken"
          @row-click="handleRowSecretToken"
          :textTitleEmpty="
            $t('message.pages.drm.drmListKeys.notFoundSearchTitle')
          "
          :textDescriptionEmpty="
            $t('message.pages.drm.drmListKeys.notFoundSearchDescription')
          "
          :menu-options="[
            {
              label: $t('message.pages.drm.drmListKeys.editKey'),
              action: 'edit',
            },
            {
              label: $t('message.actions.disable'),
              action: 'toggleStatus',
              condition: (row) => row.status_key === true,
            },
            {
              label: $t('message.actions.active'),
              action: 'toggleStatus',
              condition: (row) => row.status_key === false,
            },
            {
              label: $t('message.pages.drm.drmListKeys.removeKey'),
              action: 'delete',
              style: {
                borderTop: $vuetify.theme.dark
                  ? '1px solid #363949'
                  : '1px solid #EDEEF1',
              },
              textColor: { color: 'red' },
            },
          ]"
          @menu-action="handleMenuAction"
        >
          <template #keyHeader>
            <span class="mr-1">{{
              $t(
                'message.pages.drm.hotmartIntegration.panel15.success.privateKey'
              )
            }}</span>
            <v-tooltip bottom
              ><template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" left small
                  >panda-info-solid</v-icon
                ></template
              ><span>{{
                $t('message.pages.drm.drmListKeys.privateKeyTooltip')
              }}</span>
            </v-tooltip>
          </template>
          <template #statusCommon="{ row }">
            <v-tag :type="row.status_key ? 'default' : 'neutral'">
              {{
                row.status_key
                  ? $t('message.pages.qualitySettings.enabled')
                  : $t('message.pages.qualitySettings.disabled')
              }}
            </v-tag>
          </template>
        </BaseTable>
      </div>
      <drm-import-keys />
      <drm-upload-keys :selectedGroup="selectedDrmGroup" />
      <drm-delete-key />
      <drm-toggle-status-key />
    </section>
    <BaseAlert
      class="my-8"
      type="informative"
      v-if="
        ['ticto', 'the-members', 'memberkit', 'cademi', 'xgrow'].includes(
          selectedSourceWebhook
        ) && groupPrivateTokens.length === 0
      "
      :title="$t('message.pages.drm.drmListKeys.alert.title')"
      :description="$t('message.pages.drm.drmListKeys.alert.description')"
    >
    </BaseAlert>
    <section
      v-if="groupPrivateTokens.length === 0"
      class="align-center justify-center"
      style="height: 100%; display: grid; min-height: 450px"
    >
      <v-row
        class="d-flex flex-column"
        no-gutters
        justify="center"
        align="center"
      >
        <img
          class="emptyStateTitle mb-4"
          src="@/assets/videosEmptyState.svg"
          max-width="240"
        />
        <span class="body-regular-large textType3--text">
          {{ $t('message.pages.drm.drmListKeys.titleEmpty') }}</span
        >
        <span
          class="body-regular-small textType6--text"
          style="text-align: center; white-space: pre-line"
        >
          {{ $t('message.pages.drm.drmListKeys.descriptionEmpty') }}
        </span>
        <div class="d-flex mt-4">
          <base-btn
            class="mr-4"
            type="secondary"
            @click="openImportKeysModal"
            >{{ $t('message.pages.drm.drmListKeys.importCsv') }}</base-btn
          >
          <base-btn @click="addKey">{{
            $t('message.pages.drm.addKey')
          }}</base-btn>
        </div>
        <a
          :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
          class="mt-4 link brand-60-base--text"
          type="primary"
          size="small"
          target="_blank"
          >{{ $t('message.pages.drm.drmListKeys.moreListKey') }}
          <v-icon size="16px" class="brand-60-base--text"
            >mdi-open-in-new</v-icon
          ></a
        >
      </v-row>
      <drm-import-keys />
      <drm-upload-keys :selectedGroup="selectedDrmGroup" />
      <drm-delete-key />
      <drm-toggle-status-key />
    </section>
    <base-float-menu v-if="selectedKeys.length > 0">
      <div style="display: grid">
        <span class="body-bold-smaller neutral-20-dark--text">
          {{ selectedKeys.length }}
          {{
            selectedKeys.length > 1
              ? $t('message.selectedItems')
              : $t('message.selectedItem')
          }}</span
        >
        <span class="selectedItensSize">{{ selectedKeysSize }}</span>
      </div>
      <div style="border-left: 1px solid #d1d1d1">
        <base-btn
          @click="handleActiveStatus(selectedKeys)"
          class="ml-4"
          size="small"
          type="primary"
        >
          {{ $t('message.actions.active') }}
        </base-btn>
        <base-btn
          @click="handleDisableStatus(selectedKeys)"
          class="ml-4"
          size="small"
          type="tertiary"
        >
          {{ $t('message.actions.disable') }}
        </base-btn>
        <base-btn
          @click="handleDeleteKey(selectedKeys)"
          class="ml-4"
          size="small"
          type="danger"
        >
          {{ $t('message.remove') }}
        </base-btn>
      </div>
    </base-float-menu>
  </main>
</template>
<script>
import { mapState } from 'vuex'
import drmApi from '@/services/drmApi'
import BaseTable from '../../../components/BaseTable.vue'
import HeaderSection from './HeaderSection.vue'
import DrmImportKeys from './DrmImportKeys.vue'
import DrmUploadKeys from './DrmUploadKeys.vue'
import DrmDeleteKey from './DrmDeleteKey.vue'
import DrmToggleStatusKey from './DrmToggleStatusKey.vue'
import BaseFloatMenu from '@/components/BaseFloatMenu.vue'
import LoadingLogo from '../../../components/LoadingLogo.vue'
import BaseAlert from '../../../components/BaseAlert.vue'
export default {
  name: 'DrmListKeys',
  components: {
    BaseTable,
    HeaderSection,
    DrmImportKeys,
    DrmUploadKeys,
    DrmDeleteKey,
    DrmToggleStatusKey,
    BaseFloatMenu,
    LoadingLogo,
    BaseAlert,
  },
  props: {
    selectedDrmGroup: {
      type: Object,
      default: () => ({}),
    },
    selectedSourceWebhook: {
      type: String,
      default: 'API',
    },
  },
  data() {
    return {
      fetchingPrivateKeys: false,
      groupPrivateTokens: [],
      windowWidth: window.innerWidth,
      searchKeysText: '',
      tokenNameOrder: 'asc',
      selectedKeys: [],
      selectedGroup: {
        id: null,
      },
    }
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    tableColumns() {
      const w = this.windowWidth

      const getWidth = (
        large,
        step1,
        step2,
        step3,
        step4,
        step5,
        step6,
        step7
      ) => {
        if (w < 1360) return step7
        if (w < 1460) return step6
        if (w < 1560) return step5
        if (w < 1660) return step4
        if (w < 1760) return step3
        if (w < 1860) return step2
        if (w < 1960) return step1
        return large
      }

      return [
        {
          prop: 'key',
          label: this.$t('message.commom.key'),
          width: getWidth(160, 150, 140, 130, 120, 110, 100, 95),
        },
        {
          prop: 'string1',
          label: this.$t('message.pages.drm.field') + ' 1',
          width: getWidth(160, 150, 140, 130, 120, 110, 100, 95),
        },
        {
          prop: 'string2',
          label: this.$t('message.pages.drm.field') + ' 2',
          width: getWidth(160, 150, 140, 130, 120, 110, 100, 95),
        },
        {
          prop: 'string3',
          label: this.$t('message.pages.drm.field') + ' 3',
          width: getWidth(160, 150, 140, 130, 120, 110, 100, 95),
        },
        {
          prop: 'status',
          label: 'Status',
          width: getWidth(160, 150, 140, 130, 120, 110, 100, 95),
          slot: 'statusCommon',
          align: 'center',
        },
      ]
    },
    filteredKeys() {
      return this.groupPrivateTokens.filter((item) =>
        item.key?.toLowerCase()?.includes(this.searchKeysText.toLowerCase())
      )
    },
    checkboxIndeterminateStatusTokens() {
      return (
        this.selectedKeys.length > 0 &&
        this.selectedKeys.length < this.groupPrivateTokens.length
      )
    },
    anyTokenSelected() {
      return this.selectedKeys.length > 0
    },
  },
  methods: {
    handleMenuAction({ action, row }) {
      switch (action) {
        case 'edit':
          this.handleRowSecretToken(row)
          break
        case 'delete':
          this.handleDeleteKey(row)
          break
        case 'toggleStatus':
          this.handleToggleStatus(row)
          break
      }
    },
    handleSort({ prop, order }) {
      this.filteredKeys.sort((a, b) => {
        const valA = a[prop]
        const valB = b[prop]
        if (valA == null || valB == null) return 0

        if (order === 'asc') {
          return valA > valB ? 1 : valA < valB ? -1 : 0
        } else {
          return valA < valB ? 1 : valA > valB ? -1 : 0
        }
      })
    },
    handleDisableStatus() {
      const selectedKeys = [...this.selectedKeys]
      selectedKeys.forEach((element) => {
        element.status_key = false
      })
      this.$root.$emit('drmToggleStatusKey', {
        group: this.selectedDrmGroup,
        keys: selectedKeys,
      })
    },
    handleActiveStatus() {
      const selectedKeys = [...this.selectedKeys]
      selectedKeys.forEach((element) => {
        element.status_key = true
      })
      this.$root.$emit('drmToggleStatusKey', {
        group: this.selectedDrmGroup,
        keys: selectedKeys,
      })
    },
    handleToggleStatus(row) {
      const selectedKeys = Array.isArray(row) ? row : [row]
      selectedKeys.forEach((element) => {
        element.status_key = !element.status_key
      })
      this.$root.$emit('drmToggleStatusKey', {
        group: this.selectedDrmGroup,
        keys: selectedKeys,
      })
    },
    handleDeleteKey(row) {
      const selectedKeys = this.selectedKeys.length ? this.selectedKeys : [row]
      this.$root.$emit('drmDeleteKey', {
        group: this.selectedDrmGroup,
        keys: selectedKeys,
      })
    },
    addKey() {
      this.$root.$emit('openDrmSecretKey', {
        group: this.selectedDrmGroup,
        item: '',
        edit: false,
      })
    },
    openImportKeysModal() {
      this.$root.$emit('openDrmImportModal')
    },
    selectAllTokens() {
      if (this.selectedKeys.length === this.groupPrivateTokens.length) {
        this.selectedKeys = []
        return
      }
      this.selectedKeys = [...this.groupPrivateTokens]
    },
    switchTokenNameOrder() {
      if (!this.tokenNameOrder || this.tokenNameOrder === 'desc')
        return (this.tokenNameOrder = 'asc')
      if (this.tokenNameOrder === 'asc') return (this.tokenNameOrder = 'desc')
    },
    checkIfSelectedToken(item) {
      let foundItem = this.selectedKeys.find((searchedItem) => {
        return searchedItem.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelectionToken(item) {
      let alreadySelected = this.checkIfSelectedToken(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedKeys.filter((lookToken) => {
            return lookToken.id !== item.id
          }),
        ]
        this.selectedKeys = [...newArr]
      } else {
        this.selectedKeys.push(item)
      }
    },
    handleRowSecretToken(token) {
      this.$root.$emit('openDrmSecretKey', {
        group: this.selectedDrmGroup,
        item: token,
        edit: true,
      })
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
    async getPrivateTokens() {
      this.fetchingPrivateKeys = true
      let dataObject = {
        drm_group_id: this.selectedDrmGroup.id,
      }
      try {
        let ret = await drmApi.getDrmPrivateTokens(dataObject)
        ret.data.tokens
          ? (this.groupPrivateTokens = ret.data.tokens)
          : (this.groupPrivateTokens = [])
        console.log('get private tokens', this.groupPrivateTokens)
      } catch (e) {
        this.fetchingPrivateKeys = false
        console.log('ERR/get private tokens', e)
      }
      this.fetchingPrivateKeys = false
    },
  },
  async mounted() {
    window.addEventListener('resize', this.updateWindowWidth)
    await this.getPrivateTokens()
    this.$root.$on('reloadTokens', async () => {
      this.fetchingPrivateKeys = true
      setTimeout(async () => {
        await this.getPrivateTokens()
        this.selectedKeys = []
        this.fetchingPrivateKeys = false
      }, 400)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
}
</script>
<style lang="scss">
::v-deep .panda-search:before {
  content: '\e90f';
  font-size: 16px;
}

.displayBlock {
  display: block;
}

.displayNone {
  display: none;
}

.t-header {
  display: none;
}

a[type='primary']:visited {
  color: varFigma(brand-60-base) !important;
}
</style>
<style lang="scss" scoped>
.link {
  color: varFigma(brand-60-base) !important;
}
</style>
